<template>
    <div class="mt-4">
        <div class="whitebackgrnd">
            <div
                v-for="info in data.calculation_info"
                :key="info.left_display_text"
            >
                <div
                    class="flex"
                    style="justify-content: space-between; margin-top: -4px"
                >
                    <p
                        class="--font greytext"
                        :style="{ width: '50%', color: info.left_color_code }"
                    >
                        {{ info.left_display_text }}
                    </p>
                    <div class="flex">
                        <p
                            class="--font greytext mr-0"
                            style="text-decoration: line-through 2px #b97f67"
                            :style="{ color: info.left_color_code }"
                            v-if="info.right_display_strike_text"
                        >
                            {{ info.right_display_strike_text }}
                        </p>
                        <p  :style="{ color: info.right_color_code, }">
                            {{ info.right_display_text }}
                        </p>
                    </div>
                </div>
            </div>
            
            <!-- <div
                class="flex"
                style="justify-content: space-between; margin-top: 1rem"
            >
                <p class="--font greytext" style="width: 50%">
                    यूनिट प्राइस * कॉन्टिटी (5*200)
                </p>
                <p class="--font greytext" style="">&#8377; 1000.0</p>
            </div>
            <div class="flex" style="justify-content: space-between">
                <p class="--font greytext" style="width: 50%">
                    कृषिफाई डिस्काउंट(20%)
                </p>
                <p class="--font greentext">&#8377; 1000.0</p>
            </div>
            <div class="flex" style="justify-content: space-between">
                <p class="--font greytext" style="width: 50%">कूपन डिस्काउंट</p>
                <p class="--font greentext">&#8377; 1000.0</p>
            </div>
            <div class="flex" style="justify-content: space-between">
                <p class="--font greytext" style="width: 50%">डिलीवरी</p>
                <div class="flex">
                    <p
                        class="--font"
                        style="text-decoration: line-through; color: #707070"
                    >
                        &#8377; 100
                    </p>
                    <p class="ml-2" style="color: #b97f67; font-weight: 600">
                        फ्री
                    </p>
                </div>
            </div> -->
        </div>
        <hr style="color:grey,height:2px" class="mt-4 mb-4" v-if="data.total_amount_info" />
         <div class="whitebackgrnd"  v-if="data.total_amount_info">
            <div
                class="flex"
                style="justify-content: space-between; fontweight: 500"
            >
                <p class="--weight">{{data.total_amount_info.display_text}}</p>
                <p style="font-size: 16px">{{data.total_amount_info.value}}</p>
            </div>
        </div>
        <hr  v-if="data.payable_amount_info"/>
         <div cv-if="data.payable_amount_info" style="background-color: #f1fdf1">
            <div
                class="flex m-1"
                style="
                    justify-content: space-between;
                    font-weight: 500;
                    padding: 2px;
                    margin-left: 1rem;
                    margin-right: 1rem;
                    background-color: #f1fdf1;
                    transform: translateY(-1px)
                "
            >
                <p class="mt-2 greentext boldText">{{data.payable_amount_info.display_text}}</p>
                <p class="--font mt-2 greentext boldText">{{data.payable_amount_info.value}}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "paymentSummary",
    props: {
        data: {
            type: Object,
        },
    },
};
</script>
<style scoped>
.whitebackgrnd {
    background-color: white;
    padding: 4px;
    margin-left: 1rem;
    margin-right: 1rem;
}
.greytext {
    color: #707070;
    font-size: 16px;
    font-weight: 500;
}
.greentext {
    color: #00570d;
    font-size: 16px;
    font-weight: 500;
}
@media all and (max-width: 320px) {
    .greytext {
        color: #707070;
        font-size: 14px;
        font-weight: 500;
    }
    .greentext {
        color: #00570d;
        font-size: 14px;
        font-weight: 500;
    }
}
</style>